module.exports = __webpack_public_path__ + "static/media/map.98ebcfe9.gif";